import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import { HeaderNavigation } from "./components/HeaderNav";
import { DaveyFooter } from "./components/DaveyFooter";
import { Header } from "./components/Header";
import { HomePage } from "./pages/HomePage";
import { ResultsPage } from "./pages/ResultsPage";

function App() {
  return (
    <Router>
      <Box>
        <HeaderNavigation />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/results" element={<ResultsPage />} />
        </Routes>
        <DaveyFooter />
      </Box>
    </Router>
  );
}

export default App;
